/**
 * Nội dung tĩnh của trung tâm hỗ trợ, viết cho khách dùng app thành viên.
 * Không gọi API. Chữ ở đây người dùng đọc được — không ghi mã nội bộ của dự án.
 */

export interface SupportTopic {
  id: string;
  title: string;
  description: string;
}

export interface SupportArticle {
  id: string;
  topicId: string;
  title: string;
  summary: string;
  steps: readonly string[];
}

export const supportTopics: readonly SupportTopic[] = [
  {
    id: 'dang-nhap',
    title: 'Đăng nhập',
    description: 'Vào app bằng số điện thoại và mã xác thực. Không có mật khẩu.',
  },
  {
    id: 'diem-hang',
    title: 'Điểm và hạng',
    description: 'Xem hạng trên tab Cá nhân, lịch sử điểm và quét hóa đơn.',
  },
  {
    id: 'qua-voucher',
    title: 'Quà và voucher',
    description: 'Đổi quà bằng điểm, xem ví và đưa mã cho nhân viên.',
  },
  {
    id: 'dat-ban',
    title: 'Đặt bàn',
    description: 'Đặt bàn trước, xem bàn đã đặt và hủy đơn.',
  },
  {
    id: 'tai-khoan',
    title: 'Tài khoản',
    description: 'Sửa thông tin, thông báo, quyền dữ liệu và đăng xuất.',
  },
  {
    id: 'ho-tro',
    title: 'Hỗ trợ trong app',
    description: 'Gọi hotline, nhắn Zalo và đánh giá bữa ăn.',
  },
];

export const supportArticles: readonly SupportArticle[] = [
  {
    id: 'nhap-so',
    topicId: 'dang-nhap',
    title: 'Nhận mã và vào app',
    summary: 'App gửi mã 6 số tới số điện thoại của bạn.',
    steps: [
      'Mở app. Nhập số vào ô Số điện thoại, rồi bấm Nhận mã xác thực.',
      'Nếu app hỏi cách nhận mã, chọn kênh rồi gửi.',
      'Ở màn Nhập mã xác thực, nhập 6 số vừa tới rồi bấm Xác nhận.',
      'Chưa thấy mã thì đợi hết giây đếm, rồi bấm Gửi lại mã.',
    ],
  },
  {
    id: 'lan-dau',
    topicId: 'dang-nhap',
    title: 'Lần đầu đăng ký',
    summary: 'Số chưa có tài khoản vẫn xác thực được. Sau đó hoàn tất hồ sơ.',
    steps: [
      'Xác nhận mã xong, app mở màn Vài thông tin cuối.',
      'Nhập Họ và tên và chọn Ngày sinh.',
      'Đọc Chính sách dữ liệu, rồi đồng ý cho chương trình thành viên xử lý dữ liệu.',
      'Bấm Hoàn tất đăng ký.',
    ],
  },
  {
    id: 'khong-mat-khau',
    topicId: 'dang-nhap',
    title: 'Không có mật khẩu',
    summary: 'Không có chỗ quên mật khẩu hay đặt lại mật khẩu.',
    steps: [
      'Mỗi lần vào app, dùng lại số điện thoại và một mã xác thực mới.',
      'Muốn thoát phiên hiện tại: mở tab Cá nhân, kéo xuống cuối, bấm Đăng xuất.',
      'App hỏi Đăng xuất? trước khi thoát. Lần sau vẫn đăng nhập bằng số đó.',
    ],
  },
  {
    id: 'xem-hang',
    topicId: 'diem-hang',
    title: 'Xem điểm và hạng',
    summary: 'Hạng và điểm nằm ở tab Cá nhân, không nằm ở Trang chủ.',
    steps: [
      'Mở tab Cá nhân.',
      'Thẻ trên cùng cho biết tên hạng và số điểm.',
      'Khi thẻ đã có hạng, bấm Quyền lợi trên thẻ để mở Quyền lợi các hạng thẻ.',
    ],
  },
  {
    id: 'lich-su-diem',
    topicId: 'diem-hang',
    title: 'Xem lịch sử điểm',
    summary: 'Mỗi lần cộng hoặc trừ là một dòng. Dòng cũ không bị xóa.',
    steps: [
      'Mở tab Cá nhân.',
      'Bấm Lịch sử điểm.',
      'Dòng đảo điểm hiện riêng. Dòng tích gốc vẫn còn.',
    ],
  },
  {
    id: 'quet-hoa-don',
    topicId: 'diem-hang',
    title: 'Quét hóa đơn để tích điểm',
    summary: 'Điểm có thể chưa cộng ngay. Thu ngân xác nhận tại quầy.',
    steps: [
      'Mở tab Quét mã. Tab đang mở mặc định là Quét hóa đơn. Tab Mã thành viên là mã để nhân viên quét.',
      'Đưa mã QR in trên hóa đơn vào khung. App đọc mã và chụp cả tờ trong cùng khung hình.',
      'Bấm Gửi để tích điểm.',
      'Nếu thấy Đang chờ thu ngân xác nhận thì điểm chưa được cộng. Không cần gửi lại.',
    ],
  },
  {
    id: 'doi-qua',
    topicId: 'qua-voucher',
    title: 'Đổi quà',
    summary: 'Điểm bị trừ khi bạn xác nhận đổi, không phải lúc mới mở món.',
    steps: [
      'Mở tab Cá nhân, bấm Cửa hàng đổi quà. Màn trong app tên Đổi quà.',
      'Chọn món rồi bấm Đổi quà.',
      'Xem số điểm sẽ trừ. Đồng ý thì bấm Xác nhận đổi quà. Muốn dừng thì bấm Để sau.',
      'Món hết suất, hết lượt đổi hoặc chưa đủ điểm thì không đổi được.',
    ],
  },
  {
    id: 'vi-voucher',
    topicId: 'qua-voucher',
    title: 'Dùng voucher',
    summary: 'Đưa mã trên app cho nhân viên. Không cần đọc số mã.',
    steps: [
      'Mở tab Cá nhân, bấm Ví voucher.',
      'Vé chia thành Chưa dùng, Đã dùng và Hết hạn.',
      'Mở một vé chưa dùng, bấm Hiện mã.',
      'Đưa màn hình cho nhân viên quét.',
    ],
  },
  {
    id: 'dat-moi',
    topicId: 'dat-ban',
    title: 'Đặt bàn mới',
    summary: 'Chọn chi nhánh, số khách và khung giờ còn chỗ.',
    steps: [
      'Mở tab Chi nhánh, chọn quán, bấm Đặt bàn.',
      'Ở màn Đặt bàn trước, giữ tab Đặt mới.',
      'Chọn chi nhánh, số lượng khách, ngày và giờ còn chỗ. Ghi chú là tùy chọn. Nhà hàng cố gắng đáp ứng, không đảm bảo mọi yêu cầu.',
      'Bấm Xác nhận đặt bàn.',
    ],
  },
  {
    id: 'ban-da-dat',
    topicId: 'dat-ban',
    title: 'Xem bàn đã đặt và hủy',
    summary: 'Quá giờ giữ chỗ mà chưa tới thì đơn hết hiệu lực.',
    steps: [
      'Mở tab Cá nhân, bấm Đặt bàn của tôi. Hoặc trên màn đặt bàn, mở tab Bàn đã đặt.',
      'Thời gian giữ chỗ do chi nhánh quy định, không cố định một số phút cho mọi quán.',
      'Muốn hủy: bấm Hủy đơn rồi xác nhận. Suất trả lại cho khách khác.',
      'Muốn đổi giờ thì hủy đơn này rồi đặt lại.',
    ],
  },
  {
    id: 'sua-thong-tin',
    topicId: 'tai-khoan',
    title: 'Sửa họ tên và ngày sinh',
    summary: 'Mở từ mục Thông tin cá nhân trên tab Cá nhân.',
    steps: [
      'Mở tab Cá nhân.',
      'Trong nhóm Cài đặt, bấm Thông tin cá nhân. Màn tên Sửa thông tin.',
      'Đổi Họ và tên hoặc Ngày sinh.',
      'Bấm Lưu thay đổi.',
    ],
  },
  {
    id: 'thong-bao',
    topicId: 'tai-khoan',
    title: 'Đọc thông báo',
    summary: 'Hộp thư nằm trong tab Cá nhân.',
    steps: [
      'Mở tab Cá nhân.',
      'Bấm Thông báo.',
      'Muốn đánh dấu toàn bộ là đã đọc thì bấm Đọc hết.',
    ],
  },
  {
    id: 'quyen-du-lieu',
    topicId: 'tai-khoan',
    title: 'Dữ liệu cá nhân và đăng xuất',
    summary: 'Quyền dữ liệu và nút thoát nằm cùng tab Cá nhân.',
    steps: [
      'Mở tab Cá nhân, bấm Dữ liệu cá nhân và quyền riêng tư. Màn tên Dữ liệu cá nhân.',
      'Từ đó xem Chính sách dữ liệu.',
      'Muốn thoát app: kéo xuống cuối tab Cá nhân, bấm Đăng xuất, rồi xác nhận Đăng xuất?.',
    ],
  },
  {
    id: 'hotline-zalo',
    topicId: 'ho-tro',
    title: 'Gọi hotline hoặc nhắn Zalo',
    summary: 'Số và Zalo nằm trong app. Trang này không hiện số.',
    steps: [
      'Mở tab Cá nhân, bấm Hỗ trợ.',
      'Nếu chỉ có số điện thoại, app gọi thẳng.',
      'Nếu có Zalo, màn Hỗ trợ có Gọi hotline và Nhắn Zalo. Kênh nào chưa có thì nút đó không hiện.',
      'Cả hai đều chưa có thì app hiện Chưa có thông tin liên hệ.',
    ],
  },
  {
    id: 'danh-gia',
    topicId: 'ho-tro',
    title: 'Đánh giá bữa ăn',
    summary: 'Gửi từ tab Cá nhân. Có thể gắn với một hóa đơn.',
    steps: [
      'Mở tab Cá nhân, bấm Đánh giá bữa ăn.',
      'Ở tab Đánh giá, chọn số sao. Nhận xét là tùy chọn.',
      'Có hóa đơn thì app gắn bữa gần nhất. Muốn đổi thì bấm Đổi bữa.',
      'Bấm Gửi đánh giá. Xem lại ở tab Đánh giá của tôi.',
    ],
  },
];

export const supportContact = {
  title: 'Liên hệ',
  paragraphs: [
    'Trang này không hiện số điện thoại hay Zalo, và không nhận tin nhắn.',
    'Mở app, tab Cá nhân, mục Hỗ trợ. Trong app có Gọi hotline và Nhắn Zalo. Kênh nào chưa có thì nút đó không hiện. Cả hai chưa có thì app báo Chưa có thông tin liên hệ.',
  ],
} as const;
